module.exports = {"id":"188942","name":"Victor Wanyama","rating":"81","photo":"./data/images/photos/4/188942.png","club":{"name":"Tottenham Hotspur","logo":"./data/images/clubs/TottenhamHotspur.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VictorWanyama0.json
// module id = 4260
// module chunks = 0